import { render, staticRenderFns } from "./BlindBox.vue?vue&type=template&id=815e2a66&scoped=true&"
import script from "./BlindBox.vue?vue&type=script&lang=js&"
export * from "./BlindBox.vue?vue&type=script&lang=js&"
import style0 from "./BlindBox.vue?vue&type=style&index=0&id=815e2a66&lang=scss&scoped=true&"
import style1 from "./BlindBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815e2a66",
  null
  
)

export default component.exports